import { SisDataGridColumns } from '../../../../../components/table';

export const Columns: SisDataGridColumns = [
  {
    dataField: 'prodId',
    caption: 'ID',
    minWidth: '60',
    allowEditing: false,
  },
  {
    dataField: 'name',
    caption: 'Name',
    minWidth: '80',
  },
  {
    dataField: 'position',
    caption: 'Position',
    minWidth: '60',
  },
  {
    dataField: 'qty',
    caption: 'Qty',
    minWidth: '40',
  },
  {
    dataField: 'note',
    caption: 'Note',
    minWidth: '80',
  },
];
